import type { PatternProps } from "./shared";

export function DotsPattern({ color, salt }: PatternProps) {
	/** Render */
	return (
		<defs>
			<pattern
				id={`${salt}-dotsPattern`}
				patternUnits="userSpaceOnUse"
				width="17.5"
				height="17.5"
			>
				<circle
					cx="8.75"
					cy="8.75"
					r="2.625"
					fill={color}
				/>
			</pattern>
		</defs>
	);
}
